<template>
  <form class="phone-edit-modal" @submit.prevent="requestCode">
    <div class="title">
      Изменение телефона
      <span>
        На указанный номер будет отправлен код подтверждения
      </span>
    </div>

    <div class="edit-form">
      <ui-input
        v-model="phone"
        clearable
        mask="phone"
        validate="phone"
        class="input"
        label="Телефон*"
        placeholder="+7 (***) ***-**-**"
        :error="phoneError"
      />

      <ui-input
        v-if="codeRequested"
        v-model="code"
        :readonly="code.length === 6"
        :error="error"
        mask="code"
        ref="code"
        class="input"
        label="Код*"
        placeholder="Введите код из SMS"
      />

      <div
        v-if="codeRequested"
        class="status"
      >
        <template v-if="retryTimeoutSeconds">
          Повторная отправка возможна через {{ retryTimeout }}
        </template>
        <template v-else-if="codeRequested">
          <span @click="requestCode">
            Отправить код повторно
          </span>
        </template>
      </div>

      <ui-button
        wide
        type="submit"
        :disabled="disabledButton"
        :class="['submit', { codeRequested }]"
        :text="codeRequested ? 'Изменить' : 'Получить код'"
      />
    </div>

    <transition name="fade">
      <ui-loader
        v-if="isLoading"
        class="loader"
        size="60"
      />
    </transition>
  </form>
</template>

<script>
export default {
  name: 'phone-edit-modal',

  data() {
    return {
      phone: '',
      code: '',
      token: '',
      codeRequested: false, // код запрошен
      retryTimeoutSeconds: 0,
      error: '',
      phoneError: '',
      isLoading: false
    }
  },

  computed: {
    disabledButton() {
      return this.codeRequested ? this.code.length < 6 : !this.phoneValid && !this.phoneError;
    },

    phoneValid() {
      return this.phone.replace(/\D/g, '').length === 11;
    },

    retryTimeout() {
      const minutes = Math.floor(this.retryTimeoutSeconds / 60);
      const seconds = this.retryTimeoutSeconds - minutes * 60;
      return `${minutes ? minutes + ' мин' : ''} ${seconds} с`;
    },
  },

  watch: {
    phone() {
      this.phoneError = '';
      if (this.codeRequested)
        this.codeRequested = false;
      this.code = '';
    },

    code(val) {
      val.length === 6 ? this.verifyCode() : null;
    }
  },

  methods: {
    requestCode() {
      if (this.error) this.error = '';
      this.codeRequested = true;
      this.checkExists()
        .then(() => {
          this.codeRequested = false;
          this.phoneError = 'Введенный телефон уже существует в системе. Попробуйте авторизоваться.'
        })
        .catch(() => {
          this.$f.requestCode({ request: { phone: this.phone } })
            .then(r => {
              this.$refs.code?.focus();
              this.retryTimeoutSeconds = r.retryTimeoutSeconds;
              this.retryCountdown();
            })
            .catch(({ error = {} } = {}) => {
              this.codeRequested = false;
              this.$store.dispatch('notifications/create', {
                title: 'Ошибка',
                message: error.detail || 'Код не отправлен',
              });
            })
        })
    },

    checkExists() {
      return new Promise((resolve, reject) => {
        this.$store.$api.accountExists({ value: this.phone })
          .then(r => r.exists ? resolve(r) : reject(r))
          .catch(reject);
      });
    },

    verifyCode() {
      this.isLoading = true;
      this.$store.$api.verifyCode({ phone: this.phone, code: this.code })
          .then(r => {
            this.token = r.token;
            this.changePhone();
          })
          .catch(({ error = {} } = {}) => {
            this.code = '';
            this.isLoading = false;
            this.error = error.detail || 'Введён неверный код подтверждения';
          })
    },

    changePhone() {
      this.$store.$api.changePhone({phone: this.phone, token: this.token})
          .then(r => {
            this.$emit('change', r.phone);
            this.$emit('on-close');
            this.$store.dispatch('notifications/create', {
              type: 'success',
              title: 'Внимание!',
              message: 'Ваш телефон был изменён',
            });
          })
          .catch(({ error = {} } = {}) => {
            this.code = '';
            this.isLoading = false;

            if (error.detail) {
              this.error = error.detail;
            }
          })
    },

    retryCountdown() { // таймер
      this.retryTimeoutSeconds--;
      if (this.retryTimeoutSeconds <= 0) {
        this.retryTimeoutSeconds = 0;
        return;
      }
      setTimeout(this.retryCountdown, 1000);
    },
  }
};
</script>

<style lang="scss">
.phone-edit-modal {
  .title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;

    span {
      display: block;
      margin-top: 12px;
      font-size: 12px;
      line-height: 20px;
      font-weight: normal;
      color: $gray;
    }
  }

  .edit-form {
    .input {
      margin-top: 12px;
    }

    .status {
      margin-top: 4px;
      font-size: 12px;
      line-height: 16px;
      color: $gray_l;

      span {
        color: $blue;
        cursor: pointer;
      }
    }

    .submit {
      margin-top: 12px;
      &.codeRequested {
        margin-top: 24px;
      }
    }
  }

  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: $blue;
  }
}

@include breakpoint("desktop") {
  .phone-edit-modal {
    width: 392px;

    .title {
      span {
        line-height: 24px;
      }
    }
  }
}
</style>
